<template>
    <div class="p-5" style="display:flex;align-items: center;justify-content: center;gap:2px">
        <button v-if="systemInput" class="btn btn-success" style="width:100px;height:100px;border-radius:100px;"
            @click="modSys.show()">{{
                systemInput.system_name }}</button>
        <button v-if="baseInput" class="btn btn-success" style="width:100px;height:100px;border-radius:100px;"
            @click="modBases.show()">{{
                baseInput.base_name }}</button>
        <button type="button" class="btn btn-success input-container"
            style="width:100px;height:100px;border-radius:100px;"><input id="myInput"
                style="width:-webkit-fill-available" min="0" type="number" v-model="MQInput"><span
                class="suffix">mq</span></button>
        <button v-if="!customerInput" class="btn btn-primary" style="width:100px;height:100px;border-radius:100px;"
            @click="modCustomers.show()">Seleziona Cliente</button>
        <button v-else class="btn btn-primary" style="width:100px;height:100px;border-radius:100px;"
            @click="modCustomers.show()">{{
                customerInput.name }}</button>
    </div>
    <div class="accordion container shadow p-4 my-4" id="accordionExample" ref="orderBox">
        <div class="accordion-item mb-2" v-for="(product, i) in finalResult" :key="i">
            <h2 class="accordion-header" :id="'heading' + i">
                <button class="accordion-button d-flex justify-content-between" :class="{ collapsed: i !== 0 }"
                    type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + i"
                    :aria-expanded="i === 0 ? 'true' : 'false'" :aria-controls="'collapse' + i"
                    :style="{ opacity: product.variations.some(v => v.active) ? 1 : 0.4 }">
                    <span>{{ product.product_name }}</span>
                    <span class="ms-auto fw-bold" style="float:right">Totale: {{ product.subTotal }} {{product.listingCurrency}}</span>
                </button>
            </h2>

            <div :id="'collapse' + i" class="accordion-collapse collapse" :class="{ show: i === 0 }"
                :aria-labelledby="'heading' + i">
                <div class="accordion-body">
                    <!-- Master Product Toggle -->
                    <div class="d-flex justify-content-end align-items-center mb-3">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" :id="'toggleAll_' + i"
                                v-model="product.active" :checked="product.variations.some(v => v.active)"
                                @change="toggleProduct(product, $event.target.checked)" />
                            <label class="form-check-label" :for="'toggleAll_' + i">
                                Attiva tutte le varianti
                            </label>
                        </div>
                    </div>

                    <!-- <p class="fw-semibold mb-3">Descrizione Breve</p> -->

                    <!-- Sconto Input -->
                    <div class="row mb-4">
                        <div class="col-md-4">
                            <label class="form-label">% Sconto</label>
                            <input type="number" class="form-control" min="0" v-model="product.discount" />
                        </div>
                    </div>

                    <!-- Product Variations Table -->
                    <div class="table-responsive">
                        <table class="table table-sm table-striped align-middle text-center">
                            <thead class="table-light">
                                <tr>
                                    <th>Attivo</th>
                                    <th>Confezione</th>
                                    <th>Quantità</th>
                                    <th>Prezzo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="variation in product.variations" :key="variation.id">
                                    <td>
                                        <div class="form-check form-switch justify-content-center d-flex">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="variation.active" />
                                        </div>
                                    </td>
                                    <td>{{ variation.packaging_label }}</td>
                                    <td>{{ variation.quantità }}</td>
                                    <td>{{ variation.price }} {{product.listingCurrency}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Totals & Discounts -->
        <div class="mt-4">
            <div class="row g-3">
                <div class="col-md-4">
                    <label class="form-label">Manodopera</label>
                    <input type="number" min="0" class="form-control" v-model="manodopera" />
                </div>
                <div class="col-md-4">
                    <label class="form-label">% Sconto sul Totale</label>
                    <input type="number" min="0" class="form-control" v-model="discount" />
                </div>
            </div>

            <h4 class="mt-4 text-start fw-bold">
                Prezzo Totale: {{ finalResult.orderTotal }} {{ finalResult.listingCurrency }}
            </h4>
        </div>
    </div>

    <div class="accordion container shadow p-4 my-4" id="accordionExample" ref="">
        <h4 class="mt-4 text-start fw-bold">
            Note:
        </h4>
        <textarea class="form-control" v-model="finalResult.orderNotes" style="width:100%"></textarea>
    </div>


    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1050;">
        <div class="d-flex flex-column gap-2">
            <button class="btn btn-success rounded-circle" @click="testOrder">Salva</button>
            <button class="btn btn-success rounded-circle" @click="generatePDF">PDF</button>
        </div>
    </div>


    <div class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true" ref="modalSystems">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content shadow-lg rounded">
                <!-- Header -->
                <div class="modal-header border-0">
                    <h5 class="modal-title text-center w-100">Seleziona un Sistema</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- Body -->
                <div class="modal-body d-flex flex-column align-items-center">
                    <!-- Search -->
                    <div class="d-flex justify-content-center mb-4 w-100">
                        <input type="text" v-model="searchS" class="form-control form-control-lg rounded-pill"
                            placeholder="Cerca..." style="max-width: 500px; width: 100%;" />
                    </div>

                    <!-- System Buttons Grid -->
                    <div class="d-flex flex-wrap justify-content-center gap-3">
                        <button class="btn btn-success rounded-pill px-4 py-3" style="min-width: 100px; height: 100px;"
                            v-for="(system, i) in filteredSystems" :key="i"
                            @click="systemInput = system; modSys.hide()">
                            {{ system.system_name }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true" ref="modalBases">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content shadow-lg rounded">
                <!-- Header -->
                <div class="modal-header border-0">
                    <h5 class="modal-title text-center w-100">Seleziona una Superficie</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Body -->
                <div class="modal-body d-flex flex-column align-items-center">
                    <!-- Search -->
                    <div class="d-flex justify-content-center mb-4 w-100">
                        <input type="text" v-model="searchB" class="form-control form-control-lg rounded-pill"
                            placeholder="Cerca..." style="max-width: 500px; width: 100%;" />
                    </div>

                    <!-- Base Buttons Grid -->
                    <div class="d-flex flex-wrap justify-content-center gap-3">
                        <button class="btn btn-success rounded-pill px-4 py-3" style="min-width: 100px; height: 100px;"
                            v-for="(base, i) in filteredBases" :key="i" @click="baseInput = base; modBases.hide()">
                            {{ base.base_name }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true" ref="modalCustomers">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content shadow-lg p-4">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Seleziona un Cliente</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">

                    <!-- Search Input -->
                    <div class="d-flex justify-content-center mb-4">
                        <input type="text" class="form-control w-50" placeholder="Cerca..." v-model="searchC">
                    </div>

                    <!-- Customer Selection -->
                    <div class="d-flex flex-wrap gap-3 justify-content-center mb-4">
                        <button v-for="(customer, i) in filteredCustomers" :key="i"
                            @click="customerInput = customer; modCustomers.hide()"
                            class="btn btn-success d-flex align-items-center justify-content-center"
                            style="width: 100px; height: 100px; border-radius: 50%; text-align: center;">
                            {{ customer.name }}
                        </button>
                    </div>

                    <!-- Divider -->
                    <hr class="my-4" />

                    <!-- Create New Section -->
                    <h4 class="text-center mb-4">Crea Nuovo</h4>

                    <form class="mx-auto" style="max-width: 500px;">
                        <div class="mb-3">
                            <label for="nome" class="form-label">Nome</label>
                            <input v-model="newCustomer.name" type="text" id="nome" name="nome" class="form-control"
                                required>
                        </div>

                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input v-model="newCustomer.email" type="email" id="email" name="email" class="form-control"
                                required>
                        </div>

                        <div class="mb-3">
                            <label for="telefono" class="form-label">Telefono</label>
                            <input v-model="newCustomer.phone" type="tel" id="telefono" name="telefono"
                                class="form-control" required>
                        </div>

                        <div class="mb-4">
                            <label for="citta" class="form-label">Città</label>
                            <input v-model="newCustomer.city" type="text" id="citta" name="citta" class="form-control"
                                required>
                        </div>

                        <button type="button" class="btn btn-success w-100" @click="createNewCustomer()">
                            Salva
                        </button>
                    </form>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
import router from '../router/index.js'
import { useRoute } from 'vue-router'
import systemMethods from '../api/resources/systemMethods'
import productMethods from '../api/resources/productMethods'
import customersMethods from '../api/resources/customersMethods'
import orderMethods from '../api/resources/orderMethods'
import { ref, onMounted, computed, watch } from 'vue'
import { useLoading } from 'vue-loading-overlay'
import { Modal } from 'bootstrap'
import pdfMake, { fonts } from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import { useUserStore } from '@/stores/userStore.js';
import usersMethods from '@/api/resources/usersMethods.js'

export default {
    name: "OrderView",
    emits: ['alert'],
    setup(_, { emit }) {
        var user = useUserStore();
        const products = ref(["Prodotto 1", "Prodotto 2", "Prodotto 3", "Prodotto 4", "Prodotto 5"]);
        const active = ref(true);
        const manodopera = ref(0);
        const discount = ref(0);
        const route = useRoute()

        var modSys = ref(Modal);
        var modBases = ref(Modal);
        var modCustomers = ref(Modal);
        const modalSystems = ref(null);
        const modalBases = ref(null);
        const modalCustomers = ref(null);
        const searchS = ref("");
        const searchB = ref("");
        const searchC = ref("");

        const systems = ref([]);
        const bases = ref([]);
        const productsFromBackend = ref([]);
        const customers = ref([]);

        const systemInput = ref(null);
        const MQInput = ref(null);
        const baseInput = ref(null);
        const customerInput = ref(null);

        var yieldRules = [];

        var loader = useLoading();

        const newCustomer = ref({
            name: "",
            email: "",
            phone: "",
            city: ""
        });

        let orderBox = ref(null);
        var timer = null;

        function toHome() {
            router.push("/")
        }
        onMounted(async () => {
            modSys.value = new Modal(modalSystems.value)
            modBases.value = new Modal(modalBases.value)
            modCustomers.value = new Modal(modalCustomers.value)
            let data = await systemMethods.getSystems();
            let dataP = await productMethods.getProducts();
            let dataB = await productMethods.getBases();
            let dataC = await customersMethods.getCustomers();
            let rules = await systemMethods.yieldOverrideRules()
            yieldRules = rules.data
            systems.value = data.data;
            products.value = dataP.data;
            bases.value = dataB.data;
            customers.value = dataC.data;

            systems.value.forEach((system) => {
                if (system.id == route.query.system) {
                    systemInput.value = system;

                }
            })
            bases.value.forEach((base) => {
                if (base.id == route.query.base) {
                    baseInput.value = base;
                }
            })
            MQInput.value = route.query.mq
            await loadOffer();
        })

        async function loadOffer() {
            let lod = loader.show({ container: orderBox.value });
            if (!MQInput.value || !systemInput.value || !baseInput.value) {
                lod.hide();
                return;
            }
            let obj = {
                mqInput: MQInput.value,
                systemId: systemInput.value.id,
                baseId: baseInput.value.id
            }
            let res = await systemMethods.calculate(obj);

            lod.hide();
            productsFromBackend.value = res.data;
            /*       productsFromBackend.value.forEach((product)=>{
                    product.variations.forEach((variation)=>{variation.active = true})
                  }) */

        }

        function checkYieldRules(product, list) {
            //console.log(yieldRules)
            yieldRules.forEach((rule) => {
                if (product.prodId == rule.yield_product_id) {
                    //console.log(list)
                    list.forEach((condProd) => {
                        if (condProd.prodId == rule.condition_product_id && condProd.variations.some(v => v.active)) {
                            //console.log("OVERRIDE");
                            product.overrideYield = rule.yield_override;
                            product.useOverrideYield = true;
                            return;
                            //return(product.yield);
                            //return(rule.yield_override)
                        }
                    })
                }
            })
        }


        function calculate(resaF, variations) {
            //calcola le confezioni consigliate a partire dalla resa del prodotto e 
            let total = MQInput.value;
            let results = [];
            let options = variations;
            options.sort(function (a, b) {
                return b.packaging_value - a.packaging_value;
            });
            options.forEach((element, i) => {
                if (!resaF || resaF == 0) {
                    results.push({ variationId: element.id, confezione: element.packaging_label, quantità: 1, price: element.price });
                }
                else {
                    let resa = (1 / resaF) * element.packaging_value;
                    let amountConf = Math.floor(total / resa);
                    let resConf = total % resa;
                    if (resConf > (resa * 1) / 2) {
                        amountConf++;
                        resConf = 0;
                    }
                    total = resConf;
                    if (i === options.length - 1 && total > 0) {
                        amountConf++;
                        resConf = 0;
                    }
                    results.push({ variationId: element.id, confezione: element.packaging_label, quantità: amountConf, price: element.price });
                }

            });
            //console.log(results)
            return results;
        };

        const finalResult = computed(() => {
            let temp = productsFromBackend.value;
            var orderTotal = 0;
            temp.forEach((product) => {
                var subTotal = 0;
                product.useOverrideYield = false;
                checkYieldRules(product, temp);
                let data;
                if (product.useOverrideYield) {
                    data = calculate(product.overrideYield, product.variations.filter((e) => e.active));
                }
                else {
                    data = calculate(product.yield, product.variations.filter((e) => e.active));
                }
                product.variations.forEach((variation) => {
                    if (!variation.active) {
                        variation.quantità = 0
                    }
                    data.forEach((option) => {
                        if (option.variationId == variation.id) {
                            variation.quantità = option.quantità;
                            let sub = option.quantità * option.price;

                            subTotal += sub - (sub * product.discount / 100).toFixed(2)
                            orderTotal += sub - (sub * product.discount / 100).toFixed(2)
                        }
                    })
                })
                product.subTotal = subTotal.toFixed(2);
            });
            let tot = orderTotal + manodopera.value;
            tot = tot - (tot * discount.value / 100);
            temp.orderTotal = tot.toFixed(2)
            if(temp[0] != undefined){
                temp.listingCurrency = temp[0].listingCurrency;
            }
            //temp.listingCurrency = productsFromBackend.value[0].listingCurrency
            return temp;
        })

        watch([MQInput, baseInput, systemInput], () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                loadOffer();
                timer = null
            }, 500)
        });

        async function testOrder() {
            if (!MQInput.value || !systemInput.value || !baseInput.value || !customerInput.value) {
                emit('alert', { message: "Seleziona un cliente!", color: "red" });
                return;
            }
            let lod = loader.show()
            let order = {
                date: Date.now() / 1000,
                system_id: systemInput.value.id,
                base_id: baseInput.value.id,
                customer_id: customerInput.value.id,
                mq: MQInput.value,
                manodopera: manodopera.value,
                discount: discount.value,
                total: finalResult.value.orderTotal,
                orderNotes: finalResult.value.orderNotes ?? "",
                products: [],
                currency: finalResult.value.listingCurrency
            };
            finalResult.value.forEach((product) => {
                product.variations.forEach((variation) => {
                    if (variation.active && variation.quantità > 0) {
                        variation.discount = product.discount
                        order.products.push(variation);
                    }
                })
            })
            //console.log(order)
            await orderMethods.postOrder(order)
            lod.hide()
            emit('alert', { message: "Preventivo Salvato", color: "green" });
        }

        const filteredSystems = computed(() => {
            if (searchS.value == "") {
                return systems.value;
            }
            else {
                return systems.value.filter((e) => e.system_name.toLowerCase().includes(searchS.value.toLowerCase()))
            }
        })

        const filteredBases = computed(() => {
            if (searchB.value == "") {
                return bases.value;
            }
            else {
                return bases.value.filter((e) => e.base_name.toLowerCase().includes(searchB.value.toLowerCase()))
            }
        })

        const filteredCustomers = computed(() => {
            if (searchC.value == "") {
                return customers.value;
            }
            else {
                return customers.value.filter((e) => e.name.toLowerCase().includes(searchC.value.toLowerCase()))
            }
        })

        const generatePDF = async () => {
            if (!MQInput.value || !systemInput.value || !baseInput.value || !customerInput.value) {
                emit('alert', { message: "Seleziona un cliente!", color: "red" });
                return;
            }

            let order = JSON.parse(JSON.stringify(finalResult.value));

            order.forEach((product) => {
                product.variations = product.variations.filter((variation) => variation.active && variation.quantità);
            });

            order = order.filter((product) => product.variations.length > 0);
            // Funzione per caricare il logo come base64
            const loadLogo = () => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = 'img/background.jpg';
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        resolve(canvas.toDataURL('image/jpg'));
                    };
                    img.onerror = reject;
                });
            };

            // Ottieni il logo come base64
            const logoBase64 = await loadLogo();

            const docDefinition = {
                pageMargins: [40, 60, 40, 40],
                content: [
                    //{ image: logoBase64, width: 150, height: 50, alignment: 'center', margin: [0, 0, 0, 10] },  // Aggiungi il logo
                    { text: "Preventivo Cliente", style: "header", alignment: "center" },
                    { text: `Cliente: ${customerInput.value.name}`, style: "subheader" },
                    { text: `Data: ${new Date().toLocaleDateString()}`, style: "subheader" },
                    { text: "Dettagli Preventivo", style: "sectionHeader" },
                    {
                        table: {
                            widths: ["33%", "33%", "33%"],
                            headerRows: 1,
                            body: [
                                [
                                    { text: "Sistema", style: "tableHeader" },
                                    { text: "Superficie", style: "tableHeader" },
                                    { text: "MQ", style: "tableHeader" }
                                ],
                                [{text:systemInput.value.system_name,alignment:"center"},{text:baseInput.value.base_name,alignment:"center"} ,{text:MQInput.value,alignment:"center"} ]
                            ]
                        },
                        layout: "lightHorizontalLines",
                        margin: [40, 5, 0, 5]
                    },
                    { text: "Prodotti", style: "sectionHeader" }
                ],
                styles: {
                    header: { fontSize: 22, bold: true, margin: [0, 50, 0, 10] },
                    subheader: { fontSize: 14, margin: [40, 5, 0, 5] },
                    sectionHeader: { fontSize: 16, bold: true, margin: [40, 15, 0, 10] },
                    tableHeader: { bold: true, fillColor: "#eeeeee", alignment: "center" },
                    productHeader: { fontSize: 12, bold: true, margin: [0, 10, 0, 5] },
                    tableCell: { margin: [5, 5, 5, 5], alignment: "center" },
                    totalText: { fontSize: 14, bold: true, alignment: "right", margin: [0, 10, 0, 0] }
                },
                images: {
                    backgroundWatermark: logoBase64
                },
                background: function (currentPage, pageSize) {
                    return {
                        image: 'backgroundWatermark',
                        width: pageSize.width,  // Imposta la larghezza uguale alla larghezza della pagina
                        height: pageSize.height, // Imposta l'altezza uguale all'altezza della pagina
                        absolutePosition: { x: 0, y: 0 } // Posiziona l'immagine nell'angolo in alto a sinistra
                    };
                },
            };

            order.forEach((product) => {
                let productHeader = {
                    text: `${product.product_name} - Prezzo: ${product.listingCurrency} ${product.subTotal} ${product.discount ? `- Sconto: ${product.discount}%` : ""}`,
                    style: "productHeader",
                    margin: [40, 5, 0, 5]
                };

                let productTable = {
                    table: {
                        widths: ["50%", "50%"],
                        body: [
                            [
                                { text: "Confezione", style: "tableHeader" },
                                { text: "Quantità", style: "tableHeader" }
                            ]
                        ]
                    },
                    layout: "lightHorizontalLines",
                    margin: [40, 5, 0, 5]
                };

                product.variations.forEach((variation) => {
                    productTable.table.body.push([
                        { text: variation.packaging_label, style: "tableCell" },
                        { text: variation.quantità, style: "tableCell" }
                    ]);
                });

                docDefinition.content.push({
                    unbreakable: true,
                    stack: [
                        productHeader,
                        productTable
                    ]
                });
            });

            // Aggiungi il costo della manodopera separatamente (già calcolato)
            if (manodopera.value > 0) {
                docDefinition.content.push({ text: `Manodopera: ${finalResult.value.listingCurrency} ${manodopera.value}`, style: "totalText" });
            }

            // Aggiungi il totale finale (già calcolato)
            if (discount.value != 0) {
                docDefinition.content.push({ text: `Sconto sul totale applicato: ${discount.value}%`, style: "totalText" });
            }
            docDefinition.content.push({ text: `Totale: ${finalResult.value.listingCurrency} ${finalResult.value.orderTotal}`, style: "header", alignment: "right" });
            docDefinition.content.push({ text: `(Iva esclusa)`, alignment: "right" });

            if (finalResult.value.orderNotes && finalResult.value.orderNotes.length > 0) {
                docDefinition.content.push({ text: `Note:`, style: "sectionHeader", alignment: "left" });
                docDefinition.content.push({ text: finalResult.value.orderNotes, margin: [40, 0, 0, 10], alignment: "left" });
            }



            docDefinition.footer = function (currentPage, pageCount) {
                return {
                    margin: [40, 0, 40, 0], // Margini: [sinistra, sopra, destra, sotto]
                    columns: [
                        {
                            // Colonna Sinistra (vuota o per altri dati)
                            text: '',
                        },
                        {
                            // Colonna Destra
                            alignment: 'right',
                            stack: [
                                // Mostra il nome utente solo se è l'ultima pagina
                                (currentPage === pageCount) ? { text: user.loggedUsername, italics: true, fontSize: 14 } : '',
                                // Numero di pagina (mostrato su tutte le pagine)
                                { text: 'Pagina ' + currentPage + ' di ' + pageCount, fontSize: 10 }
                            ]
                        }
                    ]
                };
            };

            if (user.isApple) {
                pdfMake.createPdf(docDefinition).download();
            }
            else {
                pdfMake.createPdf(docDefinition).open();
            }
        };

        async function createNewCustomer() {
            let res = await customersMethods.postCustomer(newCustomer.value);
            let id = res.data
            newCustomer.value.id = id;
            customerInput.value = newCustomer.value;
            modCustomers.value.hide();
            newCustomer.value = {
                name: "",
                email: "",
                phone: "",
                city: ""
            }
            let dataC = await customersMethods.getCustomers();
            customers.value = dataC.data;
        }

        function toggleProduct(product, isActive) {
            product.variations.forEach((variation) => {
                variation.active = isActive;
            })
        }

        return {
            products, toHome, active, manodopera, discount, finalResult,
            MQInput, systemInput, baseInput,
            testOrder, orderBox,
            customers, customerInput,
            modalSystems, modalBases, modSys, modBases, modalCustomers, modCustomers,
            systems, bases, filteredSystems, filteredBases, filteredCustomers,
            searchB, searchC, searchS,
            generatePDF,
            newCustomer, createNewCustomer,
            toggleProduct
        }
    }
}
</script>
<style scoped>
.accordion-button::after {
    margin-left: 10px;
}
</style>